import React from "react";
import logger from "logger";

import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringArray } from "./StringArray";
import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";

import * as taskservice from "Utils/TaskService";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Leaderboard Download">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringArray
          label={"Selected Events"}
          array={task.taskstatusdetail.downloadevents}
          valueParser={(item) =>
            item.isselected === true
              ? `${item.eventname}(${item.eventid})`
              : null
          }
        />
        <StatusSection task={task} />
        <StringArray
          label={
            "Processed(Click on filename to download once its progress is done)"
          }
          array={task.taskstatusdetail.filestatus}
          valueParser={(item) => {
            if (item.fileready === true) {
              return (
                <div
                  onClick={(e) => {
                    taskservice.downloadfile(item.filename);
                  }}
                  className="enlargeonhover"
                  style={{ color: "green" }}
                >
                  {item.filename}
                </div>
              );
            } else {
              return (
                <div>
                  In Progress:
                  {item.eventname}({item.eventid}) -{item.pagesdone}/
                  {item.totalpages}
                </div>
              );
            }
          }}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
